import React, { useEffect, useState } from "react";

import { Drawer, Empty, message } from "antd";
import dayjs from "dayjs";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../api/ApiRoutes";

function HandDetails({ open, setOpen, gameId, selectedHand, userId }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [handDetailsItems, setHandDetailsItems] = useState({});

  const getHandDetails = async () => {
    if (!gameId || !selectedHand?.hand_number || !userId) {
      return;
    }
    let params = {
      game_id: gameId,
      hand_number: Number(selectedHand?.hand_number),
      user_id: userId,
    };
    try {
      const pokerHandsResponse = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_POKER_HAND_DETAILS,
        params
      );

      const data = pokerHandsResponse?.data?.data;
      setHandDetailsItems(data || {});
      if (!data || Object.keys(data || {}).length === 0) {
        message.info("No hand details available.");
      }
    } catch (error) {
      console.error("Error fetching hand details:", error);
      message.error("Failed to fetch hand details.");
    }
  };

  useEffect(() => {
    getHandDetails();
  }, [gameId, selectedHand, userId]);

  return (
    <Drawer
      title="Hand Details"
      closable={{ "aria-label": "Close Button" }}
      onClose={() => setOpen(false)}
      open={open}
      width={1200}
    >
      <div className="hand-details-drawer-content">
        {!handDetailsItems || Object.keys(handDetailsItems || {}).length === 0 ? (
          <Empty description="No hand details available" />
        ) : (
        <>
        <div className="hand-details-drawer-items-row">
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">Hand ID</span>
            <div className="hand-details-drawer-item-value">
              {handDetailsItems?.hand_id}
            </div>
          </div>
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">Start time</span>
            <div className="hand-details-drawer-item-value">
              {dayjs(handDetailsItems?.start_time).format("MM/DD/YYYY HH:mm:ss")}
            </div>
          </div>
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">End time</span>
            <div className="hand-details-drawer-item-value">
              {dayjs(handDetailsItems?.end_time).format("MM/DD/YYYY HH:mm:ss")}
            </div>
          </div>
        </div>
        <div className="hand-details-drawer-items-row">
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">Bet amount</span>
            <div className="hand-details-drawer-item-value">
              {Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(handDetailsItems?.bet_amount)}
            </div>
          </div>
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">
              Payout amount
            </span>
            <div className="hand-details-drawer-item-value">
              {Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
              }).format(handDetailsItems?.payout_amount)}
            </div>
          </div>
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">
              Ticket status
            </span>
            <div className="hand-details-drawer-item-value">
              {handDetailsItems?.ticket_status}
            </div>
          </div>
        </div>
        <div className="hand-details-drawer-items-row">
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">
              Player's Cards
            </span>
            <div
              className="hand-details-drawer-item-value"
              style={{ display: "flex", gap: "5px" }}
            >
              {handDetailsItems?.player_cards?.map((card) => (
                <span key={card}>{card}</span>
              ))}
            </div>
          </div>
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">
              Player's hand combination
            </span>
            <div className="hand-details-drawer-item-value">
              {handDetailsItems?.player_hand_combination}
            </div>
          </div>
          <div className="hand-details-drawer-item">
            <span className="hand-details-drawer-item-title">Decision</span>
            <div className="hand-details-drawer-item-value">
              {handDetailsItems?.decision}
            </div>
          </div>
        </div>
        <div className="poker-divider"></div>
        <div className="poker-other-players-container">
          <span className="hand-details-drawer-item-title poker-other-players-title">
            List every other players:
          </span>
          {handDetailsItems?.other_players?.map((player, idx) => (
            <div className="poker-other-players-list" key={`${player?.user_id || idx}`}> 
              <div className="hand-details-drawer-item">
                <span className="hand-details-drawer-item-title">
                  Player ID
                </span>
                <div className="hand-details-drawer-item-value">
                  {player.user_id}
                </div>
              </div>
              <div className="hand-details-drawer-item">
                <span className="hand-details-drawer-item-title">
                  Player's cards
                </span>
                <div
                  className="hand-details-drawer-item-value"
                  style={{ display: "flex", gap: "5px" }}
                >
                  {player.cards.map((card) => (
                    <span key={card}>{card}</span>
                  ))}
                </div>
              </div>
              <div className="hand-details-drawer-item">
                <span className="hand-details-drawer-item-title">
                  Player's hand combination
                </span>
                <div className="hand-details-drawer-item-value">
                  {player.hand_combination}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="poker-divider"></div>
        <div className="poker-winners-container">
          <span className="hand-details-drawer-item-title poker-other-players-title">
            List of winners:
          </span>
          {handDetailsItems?.winners?.map((player, idx) => {
            const payout =
              player?.payout_amount ??
              player?.payout ??
              player?.amount ??
              player?.winnings ??
              0;
            return (
              <div className="poker-other-players-list" key={`${player?.user_id || idx}`}>
                <>
                  <div
                    className="hand-details-drawer-item"
                    style={{ width: "49%" }}
                  >
                    <span className="hand-details-drawer-item-title">
                      Player ID
                    </span>
                    <div className="hand-details-drawer-item-value">
                      {player?.user_id}
                    </div>
                  </div>
                  <div
                    className="hand-details-drawer-item"
                    style={{ width: "49%" }}
                  >
                    <span className="hand-details-drawer-item-title">
                      Payout amount
                    </span>
                    <div
                      className="hand-details-drawer-item-value"
                      style={{ display: "flex", gap: "5px" }}
                    >
                      {Intl.NumberFormat("en-US", {
                        style: "currency",
                        currency: "USD",
                      }).format(Number(payout) || 0)}
                    </div>
                  </div>
                </>
              </div>
            );
          })}
        </div>
        <div className="poker-divider"></div>
        <div className="hand-details-drawer-items-row">
          <div className="hand-details-drawer-item" style={{ width: "49%" }}>
            <span className="hand-details-drawer-item-title">
              Community cards
            </span>
            <div className="hand-details-drawer-item-value">
              {handDetailsItems?.community_cards?.join(", ")}
            </div>
          </div>
        </div>
        {/* {handDetailsItems.map((item) => (
          <div
            className="hand-details-drawer-item"
            style={{ width: item.width }}
          >
            <span className="hand-details-drawer-item-title">{item.title}</span>
            <div className="hand-details-drawer-item-value">{item.value}</div>
          </div>
        ))} */}
        </>
        )}
      </div>
    </Drawer>
  );
}

export default HandDetails;
